import React, { PureComponent } from 'react'
import { Collapse, Table } from 'react-bootstrap'
import HitListItem from './hit_list_item'

class MediaReferences extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: true,
    }
  }

  componentDidMount() {
    if (this.props.updateMediaCount) {
      const { props } = this
      const { hitsData } = props
      let allHits = []
      if (hitsData != null && hitsData.length > 0) {
        hitsData.some((hit) => {
          if (
            hit.raw_data.content &&
            hit.raw_data.content.data &&
            hit.raw_data.content.data.hits &&
            hit.raw_data.content.data.hits.length
          ) {
            allHits = hit.raw_data.content.data.hits
            return true
          } else {
            return false
          }
        })
        this.props.updateMediaCount(this.getHits(allHits).filter((h) => !h.checked).length)
      }
    }
  }

  confirm = (hit) => (event) => {
    const { props } = this
    if (event.target.checked) {
      window.localStorage.setItem(`${props.id}-media-${hit.provider_id}`, 'checked')
      this.props.updateMediaCount(this.props.count - 1)
    } else {
      window.localStorage.removeItem(`${props.id}-media-${hit.provider_id}`)
      this.props.updateMediaCount(this.props.count + 1)
    }
  }

  getHits = (origArray) => {
    return origArray.reduce((filtered, hit) => {
      if (hit.doc.types.join(' ').includes('media') || hit.doc.types.join(' ').includes('pep')) {
        const { props } = this
        if (!hit.provider_id) {
          hit.provider_id = hit.doc.id
        }
        const checkboxState = window.localStorage.getItem(`${props.id}-media-${hit.provider_id}`)
        filtered.push({ ...hit, checked: checkboxState === 'checked' })
      }
      return filtered
    }, [])
  }

  render() {
    const { data, hitsData } = this.props
    let allHits = []
    if (hitsData != null && hitsData.length > 0) {
      hitsData.some((hit) => {
        if (
          hit.raw_data.content &&
          hit.raw_data.content.data &&
          hit.raw_data.content.data.hits &&
          hit.raw_data.content.data.hits.length
        ) {
          allHits = hit.raw_data.content.data.hits
          return true
        } else {
          return false
        }
      })
    }

    // console.log({allHits})
    // console.log({data})
    // console.log({hitsData})
    // console.log({hits})
    // console.log({mediaData})

    const hits = this.getHits(allHits)

    const chevronClass = this.state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    const alertClass = data.length > 0 ? 'label label-info-data-media' : 'label label-info-media'
    const borderRadius = this.state.open ? '10px 10px 0 0' : '10px 10px 10px 10px'
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div
          style={{ borderRadius: borderRadius, cursor: 'pointer' }}
          onClick={() => this.setState({ open: !this.state.open })}
          className='ibox-title'
        >
          <i style={{ width: '10px' }} className={chevronClass} />
          <header>PEP and Adverse Media Matches</header>
          <span style={{ float: 'right' }} className={alertClass}>
            {hits.length}
          </span>
        </div>
        <Collapse in={this.state.open}>
          <div>
            <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
              {(data && data.length) || hits.length ? (
                <Table bordered hover>
                  <thead>
                    <tr>
                      <th>Results by Name</th>
                      <th>Reviewed by Compliance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {hits.map((hit, i) => (
                      <HitListItem
                        checked={hit.checked}
                        url={hitsData[0].reference_url}
                        collapseSection={this.collapseSection}
                        confirm={this.confirm(hit)}
                        key={hit.doc ? hit.doc.id : i}
                        data={hit}
                      />
                    ))}
                  </tbody>
                </Table>
              ) : (
                <span>{'N/A'}</span>
              )}
            </div>
          </div>
        </Collapse>
      </div>
    )
  }
}

export default MediaReferences
